import { FREYA_ORIENTATION_KEY } from "../../../../common/constants";
import { FREYA_ORIENTATION } from "../../../../common/enums";

export const useCameraRotate = () => {
  const getCameraRotationStyles = () => {
    const currentOrientation = localStorage.getItem(FREYA_ORIENTATION_KEY) || FREYA_ORIENTATION.NORMAL;

    if (currentOrientation === FREYA_ORIENTATION.ROTATED_180 && window?.innerWidth < 1024) {
      return { transform: "rotate(180deg)" };
    }
    return {};
  };

  return { getCameraRotationStyles };
};
